import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';

import type { IDocument, IDocumentFile } from '../../../../types';
import { useHttpClient } from '../../../../../DynamicForm/providers/HttpClientProvider';
import { documentsQueryKeys } from '../../documents.query-keys';

export const useDocumentsQuery = (excludeFiles = true) => {
  const httpClient = useHttpClient();

  const fetchDocuments = useCallback(async () => {
    const request = await httpClient.get<IDocument[]>('/collection-flow/documents');

    return request.data;
  }, [httpClient]);

  const query = useQuery({
    queryKey: documentsQueryKeys.list().queryKey,
    queryFn: fetchDocuments,
  });

  return {
    ...query,
    data: excludeFiles
      ? query.data?.map((document: IDocument) => ({ ...document, files: [] as IDocumentFile[] }))
      : query.data,
  };
};
